module.exports = __webpack_public_path__ + "static/media/Gerald.ea51f596.png";